import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Watermark from "helpers/Watermark.js";
import { HeaderStyles, ContainerStyles, HeadingStyles, TextStyles } from "styles/style";
import { api } from "supabase/database/api.ts";
import { TextContent, PdfContent, QnAContent, VideoContent, AudioContent } from "components/content";
import { utils } from "supabase/content/utils.ts";

export default function ContentDetail({
  table = null,
  title = null
}) {
  const { id } = useParams();
  const [content, setContent] = useState(null);

  useEffect(() => {
    async function prepMaterial() {
        if (id?.length === 6){
          const data = await api.contentQueries.getContent({ table: table, date: utils.formatDate(id) });
          setContent(data);
        } else {
          const data = await api.contentQueries.getContent({ table: table, id: id });
          setContent(data);
        }
    }
    prepMaterial();
  }, [table, id]);


  return (
    <AnimationRevealPage>
      <HeaderStyles.ContentStyledHeader />
      <ContainerStyles.Container>
        <ContainerStyles.ContentWithPaddingXl>
          <HeadingStyles.HeadingRow>
            <HeadingStyles.Heading>
              <TextStyles.HighlightedText>
                {table === "scj-spop" || table === "scj-hymns" ? "Shincheonji Music" : content?.title || title }
              </TextStyles.HighlightedText>
            </HeadingStyles.Heading>
          </HeadingStyles.HeadingRow>
          <Watermark></Watermark>

          {/* Determine type of content and render accordingly based on content */}
          {/* VIDEO */}
          { content?.video_key && content?.video_key.length > 0 && (
            <VideoContent vid_key={content?.video_key} />
          )}
          {/* AUDIO */}
          { content?.audio && content?.audio.length > 0 && (
            <AudioContent audio={content} title={title} />
          )}
          {/* PDF */}
          { content?.file && content?.file.length > 0 && (
            <PdfContent
              file={content?.file}
              contents={content?.table_of_contents}
            />
          )}
          {/* TEXT */}
          { content?.content && content?.content.length > 0 && (
            <TextContent content={content?.content} />
          )}
          {/* FAQ */}
          { content?.length > 0 && content[0]?.question && content[0]?.answer && (
            <QnAContent faqs={content} />
          )}


        </ContainerStyles.ContentWithPaddingXl>
      </ContainerStyles.Container>
    </AnimationRevealPage>

  );
}